export default "__VITE_ASSET__B_HGgi6d__"